<div class="tabs-outer" #outer>
    <div class="rounded-buttons-group">
        @for (tab of visibleTabs; track tab.id) {
        <button type="button" (click)="onTabClick(tab.id)" [title]="tab.title || tab.label"
            [ngClass]="{'selected': isActive(tab.id)}">
            {{ tab.label }}
        </button>
        }

        @if(overflowTabs.length > 0){
        <button type="button" class="more-tab" [matMenuTriggerFor]="moreMenu"
            [ngClass]="{'selected': isOverflowActive()}">
            More ▾
        </button>
        <mat-menu #moreMenu="matMenu">
            @for (tab of overflowTabs; track tab.id) {
            <button mat-menu-item (click)="onTabClick(tab.id)" [title]="tab.title || tab.label">
                {{tab.label}}
            </button>
            }
        </mat-menu>
        }
    </div>
</div>

<!-- Hidden measurement row (kept styled like real tabs for accurate widths) -->
<div class="tabs-measure">
    @for (tab of tabs; track tab.id) {
    <button type="button" #measureBtn class="measure-btn">{{tab.label}}</button>
    }
    <button type="button" #moreMeasureBtn class="measure-btn">More ▾</button>
</div>